export const SANITY_PROJECT_ID = '6gzlkg4h'
export const SANITY_DATASET = 'production'
export const SANITY_API_VERSION = '2024-01-01'

/**
 * Fetches data from your Sanity project using GROQ.
 */
export const fetchSanity = async (query: string) => {
  const url = `https://${SANITY_PROJECT_ID}.api.sanity.io/v${SANITY_API_VERSION}/data/query/${SANITY_DATASET}?query=${encodeURIComponent(query)}`

  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(
      `Sanity API error: ${response.status} ${response.statusText}`,
    )
  }
  const { result } = await response.json()
  return result
}

/**
 * Helper to build image URLs from Sanity image references
 */
export const urlForSanityImage = (source: any) => {
  if (!source || !source.asset || !source.asset._ref) return ''

  const parts = source.asset._ref.split('-')
  const id = parts[1]
  const dimensions = parts[2]
  const format = parts[3]

  return `https://cdn.sanity.io/images/${SANITY_PROJECT_ID}/${SANITY_DATASET}/${id}-${dimensions}.${format}`
}

/**
 * Helper to build file URLs (like .mov or .mp4 videos) from Sanity file references
 */
export const urlForSanityFile = (source: any) => {
  if (!source || !source.asset || !source.asset._ref) return ''

  // Sanity file refs look like: file-Tb9Ew8CXIwaY6R1kjMvI0uRR-mov
  const parts = source.asset._ref.split('-')
  const id = parts[1]
  const format = parts[2]

  return `https://cdn.sanity.io/files/${SANITY_PROJECT_ID}/${SANITY_DATASET}/${id}.${format}`
}
